import { splitNameAndExtension } from './file';
export function trimFileName(fileName) {
  const {
    name,
    extension
  } = splitNameAndExtension(fileName);
  if (extension === '') {
    return name.trim();
  }
  return `${name.trim()}.${extension.trim()}`;
}